export default "__VITE_ASSET__bqfgts5T__"